import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Datetime from 'components/Shared/Datetime';
import HistoriqueCard from './HistoriqueCard';

const styles = theme => ({
    paper: {
        padding: theme.spacing(2)
    },

    container: {
        display: 'flex',
        alignItems: 'center'
    },

    containerLeft: {
        minWidth: '10%'
    },

    containerRight: {
        width: '100%'
    },

    divider: {
        margin: theme.spacing(1, 0, 1, 0)
    }
});

class Historique extends React.Component {

    render() {
        let { classes, historique, utilisateurCourantAdminOuPiloteGroupe,
            utilisateurCourantAdmin, utilisateurCourantPiloteGroupeInterlocuteurSAV, utilisateurCourantDirecteurRegionalClient,
            onClickRemoveAction, reloadHistory } = this.props;
        

        return (
            <React.Fragment>
                {historique && historique.map(x => (
                    <React.Fragment key={x.id}>
                        <div className={classes.container}>
                            <Typography className={classes.containerLeft} variant="subtitle1" align="center">
                                <Datetime withTime datetime={x.dateCreation} />
                            </Typography>

                            <div className={classes.containerRight}>
                                <HistoriqueCard
                                    action={x}
                                    utilisateurCourantAdminOuPiloteGroupe={utilisateurCourantAdminOuPiloteGroupe}
                                    utilisateurCourantAdmin={utilisateurCourantAdmin}
                                    utilisateurCourantPiloteGroupeInterlocuteurSAV={utilisateurCourantPiloteGroupeInterlocuteurSAV}
                                    utilisateurCourantDirecteurRegionalClient={utilisateurCourantDirecteurRegionalClient}
                                    onClickRemoveAction={onClickRemoveAction}
                                    reloadHistory={reloadHistory}
                                />
                            </div>
                        </div>

                        <Divider className={classes.divider} />
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }
}



Historique.propTypes = {
    classes: PropTypes.object.isRequired,
    historique: PropTypes.array.isRequired,
    reloadHistory: PropTypes.func.isRequired,
};

export default withStyles(styles)(Historique);